import httpService from "../../components/service";

export const orderWindowList = {
    namespaced: true,
    state: {
        listOrdersWindow: {},
        ordersWindow: {},
        ordersWindowById: {}
    },
    mutations: {
        LIST_ORDER_WINDOW: (state, listOrdersWindow) => {
            state.listOrdersWindow = listOrdersWindow;
        },
        ORDER_WINDOW: (state, ordersWindow) => {
            state.ordersWindow = ordersWindow;
        },
        ORDER_WINDOW_BY_ID: (state, ordersWindowById) => {
            state.ordersWindowById = ordersWindowById;
        }
    },
    getters: {
        getOrdersWindowList: state => state.listOrdersWindow,
        getOrdersWindow: state => state.ordersWindow,
        getOrdersWindowById: state => state.ordersWindowById
    },
    actions: {
        async listOrdersWindowAction(context, orderWindowId) {
            const res = await httpService.get("/countdown_future/" + orderWindowId);
            if (res.code) throw res;
            context.commit("LIST_ORDER_WINDOW", res);
            return res;
        },
        async ordersWindowAction(context, orderWindowId) {
            const res = await httpService.get("/orders_countdown/" + orderWindowId);
            if (res.code) throw res;
            context.commit("ORDER_WINDOW", res);
            return res;
        },
        async countDownByIdAction(context, id) {
            const res = await httpService.get("/countdowns/" + id);
            if (res.code) throw res;
            context.commit("ORDER_WINDOW_BY_ID", res);
            return res;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/orders/OrderWindowList.js